import {getApiUrl} from 'api/urls'
import {apiFetch} from 'lib/fetch'
import type {BookingAgency} from 'types/department'

export const show = async (id: number): Promise<BookingAgency> =>
  apiFetch.get<BookingAgency>(getApiUrl('bookingAgencies', id))
